import Select, { components, createFilter } from 'react-select';
import OptimizedMenuList from './optimized-menu-list/OptimizedMenuList';
import { colors } from "../../../../constants/colors";


function WindowedSelect({value, options, onChange, placeholder}) {

    const primaryColor = colors.primary;
    
    return (
        <Select isSearchable={true}
                        isClearable={true}
                        value={value}
                        options={options}
                        onChange={onChange}
                        styles={{
                          control: (provided, state) => {
                            return {...provided, border: 'none', borderBottom: `2px solid ${primaryColor}`, borderRadius: '0px'};
                          } 
                        }}
                        theme={theme => {
                            return {
                              ...theme,
                              colors: {...theme.colors, primary: primaryColor, neutral30: primaryColor}
                            };
                        }}
                        placeholder={placeholder}
                        components={{MenuList: OptimizedMenuList}}
                        filterOption={createFilter({ignoreAccents: false})}
                ></Select>
    )
}

export default WindowedSelect;